import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import MainLogo from "../../assests/cfi-logo.png";

const NAV_ITEMS = [
  {
    label: "Home",
    path: "/",
  },
  {
    label: "About Us",
    path: "/our-story",
    children: [
      {
        label: "Who We Are",
        path: "/our-story",
        children: [
          { label: "Our History", path: "/our-story" },
          { label: "Our Team", path: "/our-team" },
        ],
      },
      { label: "What We Believe", path: "/what-we-believe" },
      { label: "Financials", path: "/financials" },
    ],
  },
  {
    label: "Our Missions",
    path: "/training-nationals",
    children: [
      { label: "Training Nationals", path: "/training-nationals" },
      { label: "Planting Churches", path: "/planting-churches" },
      { label: "Educating Children", path: "/educating-children" },
      { label: "Providing Humanitarian Aid", path: "/providing-humanitarian-aid" },
    ],
  },
  {
    label: "Get Involved",
    path: "/prayer-partner",
    children: [
      { label: "Be a Prayer Partner", path: "/prayer-partner" },
      {
        label: "Support Us",
        path: "/sponsorship-programme",
        children: [
          { label: "Sponsorship Programme", path: "/sponsorship-programme" },
          { label: "Development Projects", path: "/development-projects" },
          { label: "Humanitarian Aid", path: "/humanitarian-aid" },
          { label: "Estate Planning", path: "/estate-planning" },
        ],
      },
      { label: "Invite Us", path: "/invite-us" },
      { label: "Go to India", path: "/go-to-india" },
    ],
  },
  {
    label: "Events",
    href: "https://www.cfibanquet.com/",
    target: "_blank",
  },
  {
    label: "Resources",
    path: "/gallery",
    children: [
      { label: "Photo Gallery", path: "/gallery" },
      { label: "Brochures", path: "/brochures" },
    ],
  },
  { label: "Contact Us", path: "/contact" },
];

function DropdownItem({ item, closeAll }) {
  const [subOpen, setSubOpen] = useState(false);
  const hasChildren = item.children && item.children.length > 0;

  const handleClick = (e) => {
    if (item.href?.startsWith("http")) {
      closeAll();
      return;
    }
    closeAll();
  };

  return (
    <li
      style={{ position: "relative" }}
      onMouseEnter={() => hasChildren && setSubOpen(true)}
      onMouseLeave={() => hasChildren && setSubOpen(false)}
    >
      {item.href ? (
        <a
          href={item.href}
          target={item.target || "_self"}
          rel="noopener noreferrer"
          onClick={handleClick}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "11px 18px",
            fontSize: "14px",
            color: "#333",
            textDecoration: "none",
            whiteSpace: "nowrap",
            borderBottom: "1px solid #f5f5f5",
            backgroundColor: subOpen ? "#faf8f5" : "transparent",
            transition: "background 0.12s, color 0.12s",
            gap: "12px",
            cursor: "pointer",
          }}
        >
          {item.label}
        </a>
      ) : (
        <Link
          to={item.path}
          onClick={handleClick}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "11px 18px",
            fontSize: "14px",
            color: "#333",
            textDecoration: "none",
            whiteSpace: "nowrap",
            borderBottom: "1px solid #f5f5f5",
            backgroundColor: subOpen ? "#faf8f5" : "transparent",
            transition: "background 0.12s, color 0.12s",
            gap: "12px",
            cursor: "pointer",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#faf8f5";
            e.currentTarget.style.color = "#c47a1e";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = subOpen ? "#faf8f5" : "transparent";
            e.currentTarget.style.color = "#333";
          }}
        >
          {item.label}
          {hasChildren && <span style={{ color: "#aaa", fontSize: "16px", lineHeight: 1 }}>›</span>}
        </Link>
      )}

      {hasChildren && subOpen && (
        <ul
          style={{
            position: "absolute",
            top: 0,
            left: "100%",
            backgroundColor: "#fff",
            boxShadow: "4px 4px 16px rgba(0,0,0,0.10)",
            listStyle: "none",
            margin: 0,
            padding: 0,
            minWidth: "180px",
            zIndex: 300,
          }}
        >
          {item.children.map((child) => (
            <DropdownItem key={child.label} item={child} closeAll={closeAll} />
          ))}
        </ul>
      )}
    </li>
  );
}

function Dropdown({ items, closeAll }) {
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        backgroundColor: "#fff",
        boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
        minWidth: "220px",
        zIndex: 200,
        borderTop: "3px solid #f4f4f4",
      }}
    >
      <div style={{ padding: "8px 0 4px 14px" }}>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "26px",
            height: "26px",
            backgroundColor: "#c47a1e",
            borderRadius: "50%",
          }}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M6 2.5V9.5M6 9.5L3 6.5M6 9.5L9 6.5"
              stroke="#fff"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>
      <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {items.map((item) => (
          <DropdownItem key={item.label} item={item} closeAll={closeAll} />
        ))}
      </ul>
    </div>
  );
}

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const closeTimer = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMouseEnter = (label) => {
    clearTimeout(closeTimer.current);
    setActiveMenu(label);
  };

  const handleMouseLeave = () => {
    closeTimer.current = setTimeout(() => setActiveMenu(null), 80);
  };

  const closeAll = () => {
    setActiveMenu(null);
    setMenuOpen(false);
  };

  return (
    <nav
      style={{
        backgroundColor: "#fff",
        borderBottom: scrolled ? "1px solid #ddd" : "1px solid #e5e7eb",
        boxShadow: scrolled ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        transition: "box-shadow 0.2s",
        fontFamily: "'Segoe UI', Arial, sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 2rem",
          maxWidth: "1200px",
          margin: "0 auto",
          height: "64px",
        }}
      >
        <Link
          to="/"
          onClick={closeAll}
          style={{ textDecoration: "none", display: "flex", alignItems: "center" }}
        >
          <img
            src={MainLogo}
            style={{ width: "7rem", height: "3rem", objectFit: "contain" }}
            alt="Christ For India"
          />
        </Link>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          className="hamburger-btn"
          style={{
            display: "none",
            flexDirection: "column",
            gap: "5px",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px",
          }}
        >
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              style={{
                display: "block",
                width: "24px",
                height: "2px",
                backgroundColor: "#333",
                borderRadius: "2px",
              }}
            />
          ))}
        </button>

        <ul
          className={`nav-links ${menuOpen ? "open" : ""}`}
          style={{
            display: "flex",
            alignItems: "center",
            listStyle: "none",
            margin: 0,
            padding: 0,
            gap: 0,
          }}
        >
          {NAV_ITEMS.map((item) => {
            const hasChildren = item.children && item.children.length > 0;
            const isActive = activeMenu === item.label;
            return (
              <li
                key={item.label}
                style={{ position: "relative" }}
                onMouseEnter={() => hasChildren && handleMouseEnter(item.label)}
                onMouseLeave={handleMouseLeave}
              >
                {item.href ? (
                  <a
                    href={item.href}
                    target={item.target || "_self"}
                    rel="noopener noreferrer"
                    onClick={closeAll}
                    style={{
                      display: "block",
                      padding: "0 14px",
                      height: "64px",
                      lineHeight: "64px",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: isActive ? "#c47a1e" : "#333",
                      textDecoration: "none",
                      whiteSpace: "nowrap",
                      borderBottom: isActive ? "2px solid #c47a1e" : "2px solid transparent",
                      transition: "color 0.15s, border-bottom 0.15s",
                    }}
                  >
                    {item.label}
                  </a>
                ) : (
                  <NavLink
                    to={item.path}
                    onClick={closeAll}
                    style={({ isActive: isLinkActive }) => ({
                      display: "block",
                      padding: "0 14px",
                      height: "64px",
                      lineHeight: "64px",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: isLinkActive || isActive ? "#c47a1e" : "#333",
                      textDecoration: "none",
                      whiteSpace: "nowrap",
                      borderBottom: isLinkActive || isActive ? "2px solid #c47a1e" : "2px solid transparent",
                      transition: "color 0.15s, border-bottom 0.15s",
                    })}
                  >
                    {item.label}
                  </NavLink>
                )}

                {hasChildren && isActive && (
                  <Dropdown items={item.children} closeAll={closeAll} />
                )}
              </li>
            );
          })}
          <li>
            <a
              href="https://www.paypal.com/donate/?hosted_button_id=Y4YKUWQE3UWWY"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeAll}
              style={{
                display: "block",
                backgroundColor: "#2d6a2d",
                color: "#fff",
                padding: "0 18px",
                height: "44px",
                lineHeight: "44px",
                fontSize: "13px",
                fontWeight: "700",
                letterSpacing: "0.5px",
                textDecoration: "none",
                marginLeft: "12px",
                whiteSpace: "nowrap",
                transition: "background 0.15s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#225522")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#2d6a2d")}
            >
              GIVE A GIFT
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
